export const RISK_QUERY = '/risks';
export const RISKS_QUERY = '/risks/list';
export const RISKS_MATRIX_QUERY = '/risks/matrix';
export const RISKS_MATRIX_SCORE_QUERY = '/risks/matrix/score';
export const RISKS_SETTINGS_QUERY = '/risks/settings';
export const RISK_NOTES_QUERY = '/risks/:id/notes';
export const SUPPLIERS_BASIC_QUERY = '/suppliers/basic';
